import React from 'react';
import {useTranslation} from 'react-i18next';
import {ChipMenu, ChipOptions} from '../builder/ChipMenu';

const ALL_RULES = '';

/**
 * «Por regla» de «Ahora»: el chip que deja la bandeja con las alertas de UNA regla personalizada
 * (`?regla=<id>`, lo mismo que arma «Ver qué disparó» de Mis reglas). Abre la lista de las reglas que
 * hoy tienen alertas y, arriba, «Todas las reglas» para soltar el filtro.
 *
 * Tiene la caja de los demás chips de la bandeja (`cav-chip`) y su contador: las vigentes que vienen
 * de reglas, o de la elegida. Sin ninguna, queda deshabilitado como los otros, salvo que esté prendido
 * (hay que poder apagarlo).
 *
 * `ruleName` es el nombre de la elegida aunque hoy no tenga alertas (sale de Mis reglas); sin él, «Regla 17».
 */
export function RuleFilterChip({rules, ruleId, ruleName, onChange}) {
    const {t} = useTranslation();
    const isOn = ruleId !== null;
    const count = isOn
        ? (rules.find((rule) => rule.id === ruleId) || {active: 0}).active
        : rules.reduce((sum, rule) => sum + rule.active, 0);
    const nameOf = (rule) => rule.name || t('alerts_center.now.rule_unnamed', {id: rule.id});
    const text = isOn
        ? t('alerts_center.now.filter_rule_on', {
            name: ruleName || t('alerts_center.now.rule_unnamed', {id: ruleId}),
            interpolation: {escapeValue: false},
        })
        : t('alerts_center.now.filter_rule');

    const options = [
        {value: ALL_RULES, label: t('alerts_center.now.filter_rule_all')},
        ...rules.map((rule) => ({
            value: rule.id,
            label: nameOf(rule),
            hint: t('alerts_center.now.group_active', {count: rule.active}),
        })),
    ];

    return (
        <ChipMenu buttonClassName={`cav-chip alc-now__rule-chip${isOn ? ' -on' : ''}`}
                  slot="now-rule" menuLabel={t('alerts_center.now.filter_rule_menu')}
                  disabled={!isOn && rules.length === 0}
                  label={(
                      <>
                          {/* El nombre se recorta; el contador, no. */}
                          <span className="alc-now__rule-name">{text}</span>
                          <span className="cav-chip__count">{count}</span>
                      </>
                  )}>
            {({close}) => (
                <ChipOptions options={options} value={isOn ? ruleId : ALL_RULES} close={close}
                             onChoose={(value) => onChange(value === ALL_RULES ? null : value)}/>
            )}
        </ChipMenu>
    );
}
